module.exports = {
  common: {
    ns: 'common',
    routeId: 40,
    isAsync: true,
  },
  home: {
    ns: 'home',
    routeId: 36,
    isAsync: true,
  },
  'cloud-market': {
    ns: 'cloud-market',
    routeId: 78,
    isAsync: true,
  },
  'portal-market': {
    ns: 'portal-market',
    routeId: 147,
    isAsync: true,
  },
  'portal-account': {
    ns: 'portal-account',
    routeId: 93,
    isAsync: true,
  },
  'portal-document': {
    ns: 'portal-document',
    routeId: 102,
    isAsync: true,
  },
  document: {
    ns: 'document',
    routeId: 30,
    isAsync: true,
  },
  'portal-operational': {
    ns: 'portal-operational',
    routeId: 104,
    isAsync: true,
  },
};
